import { initializeApollo } from '@/utils/apollo-client';
import { ApolloClient, NormalizedCacheObject } from '@apollo/client';
import { useMemo } from 'react';

export function useApollo(
  initialState: NormalizedCacheObject,
): ApolloClient<NormalizedCacheObject> {
  const store = useMemo(() => initializeApollo(initialState), [initialState]);
  return store;
}
